module.exports = __webpack_public_path__ + "img/star-outline.5d42d09e.svg";